import { render, staticRenderFns } from "./SegmentsConfiguration.vue?vue&type=template&id=3bbd04de"
import script from "./SegmentsConfiguration.vue?vue&type=script&lang=js"
export * from "./SegmentsConfiguration.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports